import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import PD1 from "../media/Activities/PD/PD1.jpg"
import PD2 from "../media/Activities/PD/PD2.jpg"
import PD3 from "../media/Activities/PD/PD3.jpg"
import PD4 from "../media/Activities/PD/PD4.jpg"
import PD5 from "../media/Activities/PD/PD5.jpg"
import PD6 from "../media/Activities/PD/PD6.jpg"
// import PD7 from "../media/Activities/PD/PD7.jpg"
// import PD8 from "../media/Activities/PD/PD8.jpg"
// import PD9 from "../media/Activities/PD/PD9.jpg"


export default function PDGallery() {
  return (
    <ImageList sx={{ width: 500, height: 500 }} cols={3} rowHeight={164}>
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srPDet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: PD1,
    title: 'PD1',
  },
  {
    img: PD2,
    title: 'PD2',
  },
  {
    img: PD3,
    title: 'PD3',
  },
  {
    img: PD4,
    title: 'PD4',
  },
  {
    img: PD5,
    title: 'PD5',
  },

  {
    img: PD6,
    title: 'PD6',
  },
  {
    img: PD2,
    title: 'PD2',
  },
  {
    img: PD2,
    title: 'PD2',
  },
  {
    img: PD2,
    title: 'PD2',
  },
//   {
//     img: PD6,
//     title: 'PD6',
//   },
//   {
//     img: PD7,
//     title: 'PD7',
//   },
//   {
//     img: PD8,
//     title: 'PD8',
//   },
//   {
//     img: PD9,
//     title: 'PD9',
//   },
];